import React from 'react'
import { Route } from 'react-router-dom'

import UnsubscribeScreen from './UnsubscribeScreen'

export default [
  <Route key='unsubscribe' path='/unsubscribe' component={UnsubscribeScreen} />
]



// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/routes.js